import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ZIndex } from 'constants/zIndex';
import { ReactNode } from 'react';
import { SafeAreaBottomStyles, SafeAreaTopStyles, ViewPortHeight } from 'ui-components/layout/styles';
import { useBodyLockScroll } from 'ui-hooks/useBodyLockScroll';
import { MODAL_ANIMATED_TIME } from 'ui-hooks/useShowModal';
import { useViewPort } from 'ui-hooks/useViewPort';

interface ModalLayoutProps {
  children: ReactNode;
  isBottom?: boolean;
  backgroundColor?: string;
  isShow: boolean;
  revealModal: boolean;
  onClick?: () => void;
}

export const ModalLayout = ({
  children,
  isBottom,
  backgroundColor,
  isShow,
  revealModal,
  onClick,
}: ModalLayoutProps) => {
  const { height: viewportHeight } = useViewPort();

  useBodyLockScroll(isShow);

  if (!isShow) {
    return null;
  }

  return (
    <StyledContainer height={viewportHeight} backgroundColor={backgroundColor} isBottom={isBottom} onClick={onClick}>
      <StyledContent isBottom={isBottom}>
        <StyledWrapper revealModal={revealModal}>{children}</StyledWrapper>
      </StyledContent>
    </StyledContainer>
  );
};

const StyledContainer = styled.div(
  ({
    backgroundColor,
    height,
    isBottom = false,
  }: {
    backgroundColor?: string;
    height: number;
    isBottom?: boolean;
  }) => css`
    background-color: ${backgroundColor || 'rgba(113, 118, 123, 0.54)'};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    ${ViewPortHeight(height)};
    z-index: ${ZIndex.Modal};

    ${SafeAreaTopStyles()}
    ${!isBottom && SafeAreaBottomStyles()}
  `,
);

const StyledContent = styled.div(
  ({ isBottom = false }: { isBottom?: boolean }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: ${isBottom ? 'flex-end' : 'center'};
  `,
);

const StyledWrapper = styled.div(
  ({ revealModal }: { revealModal: boolean }) => css`
    opacity: ${revealModal ? 1 : 0};
    transform: translateY(${revealModal ? 0 : '20%'});
    transition:
      opacity ${MODAL_ANIMATED_TIME}s ease-in-out,
      transform ${MODAL_ANIMATED_TIME}s ease-in-out;
  `,
);
